import { render, staticRenderFns } from "./AccessControlForm.vue?vue&type=template&id=00b9e0ea&"
import script from "./AccessControlForm.vue?vue&type=script&lang=js&"
export * from "./AccessControlForm.vue?vue&type=script&lang=js&"
import style0 from "./AccessControlForm.vue?vue&type=style&index=0&id=00b9e0ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports